export default __webpack_public_path__ + "static/media/flexline_logo_en.25b1d213.png";